import { endSessionAndGoHome, sessionExpiredStore } from '@/shared/api'
import { UiButton, UiModal } from '@/shared/ui'
import { useSyncExternalStore } from 'react'

/** Modal chặn khi phiên hết hạn / bị đăng xuất: không đóng được, chỉ có "Đăng nhập lại". */
export default function SessionExpiredModal() {
  const open = useSyncExternalStore(sessionExpiredStore.subscribe, sessionExpiredStore.getSnapshot)

  return (
    <UiModal
      open={open}
      title="Phiên đăng nhập hết hạn"
      closable={false}
      mask={{ closable: false }}
      keyboard={false}
      centered
      footer={
        <UiButton type="primary" onClick={endSessionAndGoHome}>
          Đăng nhập lại
        </UiButton>
      }
    >
      Phiên đăng nhập của bạn đã kết thúc. Vui lòng đăng nhập lại để tiếp tục.
    </UiModal>
  )
}
